import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AppState } from '../../app/store';
import { ContentRecord, getContent } from '../../utils/airtable-api';
import { FetchStatus } from '../../utils/fetch-status';
import { Content, ContentType } from './content';

export type ContentState = {
  content: {
    status: FetchStatus;
    data: null | Content[];
    error: null | string;
  };
};

export const fetchContent = createAsyncThunk(
  'content/fetchContent',
  async(pilgrimageId : string) => getContent(pilgrimageId)
);

export const contentSlice = createSlice({
  name: 'content',
  initialState: {
    content: {
      status: FetchStatus.Idle,
      data: null,
      error: null
    }
  } as ContentState,
  reducers: {
    setContent: (state, action: { payload: ContentState }) => state = action.payload,
  },
  extraReducers: builder => {
    builder.addCase(fetchContent.pending, (state, action) => {
      state.content.status = FetchStatus.Pending;
      state.content.data = null;
    });
    builder.addCase(fetchContent.fulfilled, (state, action) => {
      state.content.status = FetchStatus.Fulfilled;
      state.content.error = null;
      state.content.data = action.payload.records.map((record : ContentRecord) => {
        const type : ContentType = ({
          'Video': ContentType.Video,
          'Photo': ContentType.Photo,
          'Text':  ContentType.Text
        } as Record<string, ContentType>)[record.fields.Type];
        return {
          type,
          id: record.id,
          unlocked_after: record.fields.Unlocked_After,
          author: record.fields.Author,
          title: record.fields.Title,
          url: record.fields.Attachments?.length > 0 ? record.fields.Attachments[0].url : null,
          content: record.fields.Content,
          attachments: (record.fields.Attachments || []).map(attachment => attachment.url),
          youtube_url: record.fields.YoutubeURL,
          scripture: record.fields.Scripture
        }
      });
    });
    builder.addCase(fetchContent.rejected, (state, action) => {
      state.content.status = FetchStatus.Rejected;
      state.content.error = action.error.message || null;
    });
  }
});

export const { setContent } = contentSlice.actions;

export const selectContent = (state : AppState) => state.content;

export default contentSlice.reducer;